import { isFuture } from "date-fns";
import type { RouteLocationRaw } from "vue-router";

import { useEventCache } from "~/business-areas/event/composables/event-cache.hook";
import type { EventApiView } from "~~/model/event.model";

export type EventView = EventApiView & {
  teacher?: EventApiView["teachers"][number];
  is_upcoming: boolean;
  _links: {
    page: RouteLocationRaw;
  };
};

export async function useEventView(slug: string) {
  const cache = useEventCache();
  const cachedData = cache.getBySlug(slug);

  const query = await useFetch(`/api/events/${slug}`, {
    lazy: !!cachedData,
    default: () => cachedData,
    transform(data) {
      if (!data) return null;

      const view: EventView = {
        ...data,
        teacher: data.teachers.length === 1 ? data.teachers[0] : undefined,
        is_upcoming: isFuture(new Date(data.start_date!)),
        _links: {
          page: {
            name: "events-slug",
            params: {
              slug: data.slug,
            },
          },
        },
      };

      return view;
    },
  });

  if (!query.data.value)
    throw createError({
      statusCode: 404,
    });

  cache.setMultiple([query.data.value]);

  return {
    ...query,
    data: query.data as Ref<EventView>,
  };
}
